import React, { createContext, useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import { pick, isEmpty } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { apiPost, apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import io from "socket.io-client";
import { toast } from "wc-toast";
import secureLocalStorage from "react-secure-storage";

const AuthContext = createContext({});
export default AuthContext;

// Defensively decode the JWT in localStorage. If the stored value is
// stale, corrupted, or not a JWT at all, drop it and treat the user
// as logged-out instead of crashing the entire React tree.
const safeDecodeToken = () => {
  const token = localStorage.getItem("token");
  if (!token) return "";
  try {
    return jwt_decode(token);
  } catch (e) {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    return "";
  }
};

const safeDecode = (token) => {
  if (!token) return null;
  try {
    return jwt_decode(token);
  } catch (e) {
    return null;
  }
};

export const AuthProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  let [user, setUser] = useState(safeDecodeToken);
  const [inplaySocket, setInplaySocket] = useState({});
  const [casinoComingSoonModel, setCasinoComingSoonModel] = useState(false);
  const [gameFooter, setGameFooter] = useState(false);
  const [casinoRangeAmount, setCasinoRangeAmount] = useState(0);
  const [marketDepthData, setMarketDepthData] = useState({});
  const [marketDepth, setMarketDepth] = useState(false);
  const [casinoModel, setCasinoModel] = useState(false);
  const [casinoObj, setCasinoObj] = useState({});
  const [egtCasinoModel, setEgtCasinoModel] = useState(false);
  const [egtCasinoObj, setEgtCasinoObj] = useState({});
  const [fancyrules, setFancyRules] = useState(false);
  const [premiumFancyRules, setPremiumFancyRules] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [loader, setLoader] = useState(false);
  const [openBetsToogle, setOpenBetsToogle] = useState(false);
  const [searchToogle, setSearchToogle] = useState(false);
  const [settingToogle, setSettingToogle] = useState(false);
  const [announcmentToogle, setAnnouncmentToogle] = useState(false);
  const [walletOpen, setWalletOpen] = useState(false);
  const [openBetSelection, setOpenBetSelection] = useState("open");
  const [isLoged, setIsLoged] = useState("");
  let [loading, setLoading] = useState(false);
  const [sokcetId, setSocketId] = useState({});
  const [open, setOpen] = useState(true);
  const [content, setContent] = useState(false);
  const [slug, setSlug] = useState("");
  const handleContentToggle = () => {
    setContent(!content);
  };
  const [isTv, setIsTv] = useState({
    status: true,
    id: "",
  });
  const [checkRefresh, setCheckRefresh] = useState(true);
  let [user_coins, setUserCoins] = useState({
    exposure: 0.0,
    totalCoins: 0.0,
  });
  let today = new Date();
  let days = 86400000;
  let fiveDaysAgo = new Date(today - 30 * days);
  const [plDateType, setPlDateType] = useState("");
  const [plDate, setPlDate] = useState([
    {
      startDate: fiveDaysAgo,
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [visiterId, setVisiterId] = useState("");
  const [amountDeposit, setAmountDeposit] = useState({
    amount: "",
    check: false,
  });
  const [downloadBar, setShowDownloadBar] = useState(true);
  const [showRegForm, setShowRegForm] = useState(false);
  const [affiliate, setAffiliate] = useState("");
  const [active, setActive] = useState("sports");
  const [searchTab, setSearchTab] = useState(false);
  const [announcement, setAnnouncement] = useState(false);
  const [showWidget, setShowWidget] = useState(true);
  const [activeWidget, setActiveWidget] = useState("");
  const [scrollHeight, setScrollHeight] = useState(75);
  const [footerLink, setFooterLink] = useState({
    status: false,
    type: "",
  });
  const [showDate, setShowDate] = useState({
    status: false,
    type: "",
  });
  const [isChangeDate, setIsChangeDate] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [showPosition, setShowPosition] = useState({
    status: false,
    object: {},
  });
  const [getSendOtpStatus, setSendOtpStatus] = useState(false);
  const [refreshAmountLoader, setRefreshAmountLoader] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [keyTime, setKeyTime] = useState("in_play");
  const [gameTab, setGameTab] = useState("cricket");
  const [casinoIframeUrl, setCasinoIframeUrl] = useState("");
  const [showCasinoIframe, setShowCasinoIframe] = useState(false);
  // Mini-casino (ludoexchange) bottom-sheet lobby
  const [showMiniCasino, setShowMiniCasino] = useState(false);
  const [registerData, setRegisterData] = useState({});
  const [lang, setLang] = useState("en");
  const [messagelist, setMessageList] = useState([]);
  const [message, setMessage] = useState({
    status: false,
    message: "",
    errorType: "",
  });

  useEffect(() => {
    if (location?.pathname?.split("/")[1] !== "match-details") {
      setIsTv({ id: "", status: false });
    }
    // if (location?.pathname?.split("/")[1] !== "match-details") {
    //   secureLocalStorage.removeItem("betFair");
    //   secureLocalStorage.removeItem("bookmaker");
    //   secureLocalStorage.removeItem("fancy");
    //   secureLocalStorage.removeItem("tie");
    //   secureLocalStorage.removeItem("premiumFancy");
    // }
  }, [location?.pathname]);

  useEffect(() => {
    if (showSidebar) {
      setShowSidebar(false);
    }
    if (location?.pathname?.split("/")[1] !== "full-market") {
      secureLocalStorage.removeItem("betFair");
      secureLocalStorage.removeItem("bookmaker");
      secureLocalStorage.removeItem("fancy");
      secureLocalStorage.removeItem("tie");
      setShowWidget(true);
      setActiveWidget("");
    }
    if (location?.pathname?.split("/")[1] !== "deposit") {
      setAmountDeposit({
        amount: "",
        check: false,
      });
    }
    if (location?.pathname?.split("/")[1] !== "profit-and-loss") {
      setShowDate({
        status: false,
        type: "",
      });
      setPlDate([
        {
          startDate: fiveDaysAgo,
          endDate: new Date(),
          key: "selection",
        },
      ]);
    }
  }, [location]);

  const [parly, setParly] = useState(false);
  const [parlyBet, setParlyBet] = useState([]);
  const [showParlyBet, setShowParlyBet] = useState(false);
  useEffect(() => {
    if (localStorage.getItem("parly") == "true") {
      setParly(true);
    } else {
      setParly(false);
    }
  }, []);
  const updateParly = (value) => {
    localStorage.setItem("parly", value);
    setParly(value);
  };
  useEffect(() => {
    if (secureLocalStorage.getItem("parlyBet")?.length > 0) {
      setParlyBet(secureLocalStorage.getItem("parlyBet"));
    }
  }, []);

  const handleShowSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  let logoutUser = () => {
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    navigate("/");
    setShowSidebar(false);
  };

  useEffect(() => {
    if (
      location?.pathname?.split("/")[1] !== "match-details" &&
      !isEmpty(sokcetId)
    ) {
      sokcetId.disconnect();
      setSocketId({});
    }
    if (
      location?.pathname?.split("/")[1] !== "inplay" &&
      !isEmpty(inplaySocket)
    ) {
      inplaySocket.disconnect();
      setInplaySocket({});
    }
  }, [location]);
  const [socketObj, setSocketObj] = useState(null);
  const amounutRefresh = async () => {
    if (!isEmpty(socketObj)) {
      socketObj.disconnect();
    }
    const newSocket = io(
      `${import.meta.env.VITE_SOCKET}?token=${localStorage.getItem(
        "token"
      )}&userType=front`,
      {
        transports: ["websocket"],
      }
    );
    const coinListener = (message) => {
      setUserCoins(message.results);
    };

    const forceLogout = (message) => {
      const uniqueId = localStorage.getItem("uniqueId");
      if (uniqueId !== message.results.uniqueId) {
        logoutUser();
      }
    };
    setSocketObj(newSocket);
    newSocket.emit("getCoins", { user_id: user ? user.user._id : "" });
    newSocket.on("listenGetCoin", coinListener);
    newSocket.on("listenForceLogout", forceLogout);
    newSocket.on("getCoinEvent", getCoinEvent);
    newSocket.on("disconnect", function () {
      newSocket.connect();
    });
    return () => newSocket.close();
  };

  const getCoinEvent = async () => {
    if (!isEmpty(user)) {
      const { status, data } = await apiGet(apiPath.refreshAmount);
      if (status === 200) {
        if (data.success) {
          setUserCoins({
            exposure: data?.results?.exposure,
            totalCoins: data?.results?.totalCoins,
          });
        }
      }
    }
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      amounutRefresh();
    }
  }, [user, checkRefresh]);

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden && user && !checkRefresh) {
      if (!isEmpty(socketObj)) {
        socketObj.disconnect();
      }
      setCheckRefresh(true);
    } else {
      setCheckRefresh(false);
    }
  });

  const [scoreSocket, setScoreSocket] = useState({})
  const [inPlayScore, setInPlayScore] = useState([])

  const initScoreSocket = () => {
    if (!isEmpty(scoreSocket)) {
      scoreSocket.disconnect();
    }
    let randomId = user?.user?._id ? user?.user?._id : 112233;
    const newSocket = io(
      `${import.meta.env.VITE_SOCKET}?user_id=112233`,
      {
        transports: ["websocket"],
      }
    );
    setScoreSocket(newSocket);

    newSocket.emit("getScore");

    const scoreListener = (message) => {
      if (message?.status && message?.data) {
        setInPlayScore(message.data);
      }
    };

    newSocket.on("getScore", scoreListener);
    newSocket.on("disconnect", function () {
      console.log("Score socket disconnected, reconnecting...");
      newSocket.connect();
    });
    return () => newSocket.close();
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      initScoreSocket();
    }
  }, [user]);

  let loginUser = async (body) => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    body.website = hostname || "SABAEXCH";
    const { status, data } = await apiPost(
      apiPath.loginUser,
      pick(body, ["username", "password", "uniqueId", "website"])
    );
    if (status === 200) {
      if (data.success) {
        localStorage.setItem("token", data.results.token);
        localStorage.setItem("refresh_token", data.results.refresh_token);
        setUserCoins({
          exposure: data.results.exposure,
          totalCoins: data.results.totalCoins,
        });
        setUser(safeDecode(data.results.token));
        console.log(user, 'ser?.user?.pass_changed');

        if (data?.results?.pass_changed === false) {
          navigate("/change-password");
        } else {
          // delay navigation so caller can show a loading screen
          setTimeout(() => navigate("/"), 300);
        }
        // navigate("/");
        // setTimeout(() => {
        //   navigate("/");
        //   window.location.reload();
        // }, 500);
        //setLoader(false);
        setIsLoged("loged");
      } else {
        //setLoader(false);
        setIsLoged("failed");
        toast.error(data?.message);
      }
    } else {
      //setLoader(false);
      setIsLoged("failed");
      toast.error(data?.message);
    }
  };


  useEffect(() => {
    if (!isEmpty(user)) {
      // console.log(user?.user?.pass_changed, 'user?.user?.isPasswordReset');

      if (user?.user?.pass_changed === false) {
        navigate("/change-password");
        // navigate("/");
      }
    }
  }, [user]);

  const launchCasino = async (request) => {
    if (request?.platForm || request?.gameType || request?.casinoType) {
      setLoader(true);
      const { status, data: response_users1 } = await apiPost(
        apiPath.casinoAmountAdd,
        { amount: 0, platForm: request?.platForm }
      );
      if (status === 200) {
        if (response_users1.success) {
          const { status, data: response_users } = await apiPost(
            request?.platForm && request?.gameType && request?.casinoType
              ? apiPath.doLoginAndLaunchGame
              : apiPath.casinoWalletLogin,
            request?.platForm && request?.gameType && request?.casinoType
              ? {
                userId: response_users1?.results?.aeCasinoUserId,
                platForm: request?.platForm == "1" ? "" : request?.platForm,
                gameType: request?.gameType,
                gameCode: request?.casinoType,
                isLobbyTrue: request?.isLobbyTrue,
              }
              : {
                userId: response_users1?.results?.aeCasinoUserId,
                gameType: request?.gameType,
                platForm: request?.platForm == "1" ? "" : request?.platForm,
              }
          );
          if (status === 200) {
            if (response_users.status) {
              setLoader(false);
              if (response_users.data.status === "0000") {
                // Open the casino game inside an in-app iframe modal instead
                // of a full-page redirect.
                setCasinoIframeUrl(response_users.data.url);
                setShowCasinoIframe(true);
              } else {
                setLoader(false);
                toast.error(response_users?.data?.desc);
              }
            } else {
              setLoader(false);
              toast.error(response_users?.message);
            }
          } else {
            setLoader(false);
            toast.error(response_users?.message);
          }
        } else {
          setLoader(false);
          toast.error(response_users1?.message);
        }
      } else {
        setLoader(false);
        toast.error(response_users1?.message);
      }
    } else {
      setCasinoComingSoonModel(true);
      setLoader(false);
    }
  };

  const [eGTGoConnection, setEGTGoConnection] = useState(false);

  const launchEGTCasino = async (request) => {
    //console.log('request-------------------', request)
    if (request?.platForm || request?.gameType || request?.casinoType) {
      setLoader(true);
      const { status, data: response_users1 } = await apiPost(
        apiPath.easytogoCasinoAmountAdd,
        {
          prod: request?.platForm,
          type: request?.gameType,
        }
      );
      if (status === 200) {
        if (response_users1.success) {
          const { status, data: response_users } = await apiPost(
            apiPath.doLoginAndLaunchEasyToCasino,
            {
              prod: request?.platForm,
              type: request?.gameType,
              gameCode: request?.casinoType,
              gameid: request?.gameid || false,
            }
          );
          if (status === 200 && response_users.status) {
            // console.log('response_users0', response_users)
            setLoader(false);
            if (response_users.data.err === 1) {
              localStorage.setItem("launchEGTCasino", request?.platForm);
              window.location.href = response_users.data.url;
            } else {
              toast.error(response_users?.message);
              setLoader(false);
            }
          } else {
            toast.error(response_users?.message);
            setLoader(false);
          }
        } else {
          toast.error(response_users1?.message);
          setLoader(false);
        }
      } else {
        toast.error(response_users1?.message);
        setLoader(false);
      }
    } else {
      setCasinoComingSoonModel(true);
      setLoader(false);
    }
  };
  const launchGis = async (request) => {
    //console.log('request-------------------', request)
    if (request?.gameid) {
      setLoader(true);

      const { status, data: response_users } = await apiPost(
        apiPath.doLoginAndLaunchGisCasino,
        {
          gameid: request?.gameid || false,
        }
      );
      if (status === 200 && response_users.status) {
        // console.log('response_users0', response_users)
        setLoader(false);
        if (response_users.data.err === 1) {
          window.location.href = response_users.data.url;
        } else {
          toast.error(response_users?.message);
          setLoader(false);
        }
      } else {
        toast.error(response_users?.message);
        setLoader(false);
      }
    } else {
      toast.error("Game code missing");
      setLoader(false);
    }
  };
  const dolaunchCasinoNew = async (request) => {
    if (request?.gameCode) {
      const { status, data: response_users1 } = await apiPost(
        apiPath.doLoginAndLaunchIQCasino,
        {
          gameid: request?.gameCode,
          legacy: request?.legacy || "",
        }
      );
      if (status === 200) {
        if (response_users1.status) {
          window.location.href = response_users1.data;
        } else {
          toast.error(
            response_users1?.message == "success"
              ? "Casino is in maintenance mode if you have any query please contact upline"
              : response_users1?.message ||
              "Casino is in maintenance mode if you have any query please contact upline"
          );
        }
      }
    }
  };
  const getEGTCasinoBalance = async (prod) => {
    // localStorage.removeItem("launchEGTCasino");
    const { status, data: response_users } = await apiGet(
      apiPath.getEGTCasinoAmount + "?prod=" + prod
    );
    if (status === 200) {
      if (response_users.success) {
        console.log("response_users", response_users);
      }
    }
  };

  useEffect(() => {
    const launchEGTCasinoStatus = localStorage.getItem("launchEGTCasino");
    if (!isEmpty(user) && launchEGTCasinoStatus) {
      getEGTCasinoBalance(launchEGTCasinoStatus);
    }
  }, [eGTGoConnection]);

  document.addEventListener("visibilitychange", function () {
    const launchEGTCasinoStatus = localStorage.getItem("launchEGTCasino");
    // console.log('launchEGTCasinoStatus', launchEGTCasinoStatus)
    if (!document.hidden && launchEGTCasinoStatus) {
      setEGTGoConnection(true);
    }
  });

  const sendOTP = async (body, type) => {
    const { status, data } = await apiPost(apiPath.sendOTP, {
      phone_number: body?.mobile,
      country_code: body?.countryCode,
      refreralCode: body?.refreralCode || "",
      visiterId: visiterId || "",
    });
    if (status === 200) {
      if (data.success) {
        if (type == "resend") {
          toast.success("OTP resend successfully");
        }
        if (data?.results?.alreadyRegistered == 1) {
          navigate("/pin");
          setRegisterData({
            mobile: body?.mobile,
            countryCode: body?.countryCode,
            alreadyRegistered: true,
          });
        } else {
          setRegisterData({
            mobile: body?.mobile,
            countryCode: body?.countryCode,
            otp: data?.results?.otp,
            refreralCode: body?.refreralCode,
          });
          navigate("/otp");
        }
      } else {
        setRegisterData({});
        toast.error(data?.message);
      }
    } else {
      setRegisterData({});
      toast.error(data?.message);
    }
  };

  const otpVerify = async (body) => {
    let id = Math.random() * 10000;
    const { status, data } = await apiPost(apiPath.otpVerify, {
      otp: body,
      phone_number: registerData?.mobile,
      country_code: registerData?.countryCode,
      uniqueId: id,
      visiterId: visiterId || "",
    });
    if (status === 200) {
      if (data.success) {
        setRegisterData({
          ...registerData,
          otp: body?.otp,
          id: id,
        });
        if (data?.results?.alreadyRegistered == 0) {
          navigate("/pin");
        } else {
          localStorage.setItem("token", data.results?.token);
          localStorage.setItem("refresh_token", data.results?.refresh_token);
          setUser(safeDecode(data?.results?.token));
          navigate("/");
        }
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error(data?.message);
    }
  };

  const createPinFunc = async (body) => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    const { status, data } = await apiPost(apiPath.createPin, {
      phone_number: registerData?.countryCode + registerData?.mobile,
      pin: body?.pin,
      uniqueId: registerData?.id,
      refreralCode: registerData?.refreralCode || "",
      visiterId: visiterId || "",
    });
    if (status === 200) {
      if (data.success) {
        localStorage.setItem("token", data.results?.token);
        localStorage.setItem("refresh_token", data.results?.refresh_token);
        setUser(safeDecode(data?.results?.token));
        navigate("/");
        secureLocalStorage.setItem("mobile", {
          mobile: data.results?.username,
          isVerified: true,
        });
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error(data?.message);
    }
  };

  const withoutLogin = () => {
    navigate("/login");
    setShowRegForm(true);
  };

  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const [wType, setWtype] = useState(0);

  const sendMobileOTP = async (type, phone_number, MsgType) => {

    if (phone_number && type) {
      const { status, data } = await apiPost(apiPath.userSendOtp, {
        phone_number: phone_number,
        visiterId: visiterId || "",
        type: MsgType ? MsgType : ""
      });
      if (status === 200) {
        if (data.success) {
          if (type == "resend") {
            toast.success("OTP resend successfully");
          } else {

            toast.success("OTP sent successfully");
          }
          setWtype(MsgType)
          setSendOtpStatus(true)
          setMinutes(1);
          setSeconds(30);
        } else {

          toast.error(data?.message);
        }
      } else {

        toast.error(data?.message);
      }
    } else {
      toast.error("please enter correct mobile number");
    }

  };

  const getProfileData = async () => {
    const data = await apiGet(apiPath.userProfile);
    if (data?.status == 200) {
      if (data?.data?.success) {
        setProfileData(data?.data?.results);
        setUserCoins({
          exp: data?.data?.results?.exposure,
          balance: data?.data?.results?.totalCoins,
        });
      }
    }
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      getProfileData();
      messageList1(); // Uncomment if needed
    }
  }, [user]);

  const messageList1 = async () => {
    const { status, data: response_users } = await apiGet(apiPath.messageList);
    if (status === 200) {
      if (response_users.success) {
        setMessageList(response_users.results);
      }
    }
  };
  // console.log(openBetsToogle)
  const userCoins = user_coins
  let contextData = {
    user: user,
    loginUser: loginUser,
    logoutUser: logoutUser,
    user_coins,
    userCoins,
    setUserCoins: setUserCoins,
    setOpenBetsToogle,
    openBetsToogle,
    setSettingToogle,
    settingToogle,
    setAnnouncmentToogle,
    announcmentToogle,
    setSearchToogle,
    searchToogle,
    setLoader,
    loader,
    isLoged,
    setIsLoged,
    setIsTv,
    isTv,
    setWalletOpen,
    walletOpen,
    setProfileData,
    plDate,
    setPlDate,
    plDateType,
    setPlDateType,
    profileData,
    setFancyRules,
    fancyrules,
    setPremiumFancyRules,
    premiumFancyRules,
    setCasinoModel,
    casinoModel,
    setCasinoRangeAmount,
    casinoRangeAmount,
    setCasinoObj,
    casinoObj,
    setOpenBetSelection,
    openBetSelection,
    setMarketDepth,
    marketDepth,
    setMarketDepthData,
    marketDepthData,
    amounutRefresh,
    setGameFooter,
    gameFooter,
    open,
    setOpen,
    content,
    setContent,
    slug,
    setSlug,
    handleContentToggle,
    launchCasino,
    setCasinoComingSoonModel,
    casinoComingSoonModel,
    launchEGTCasino,
    egtCasinoObj,
    setEgtCasinoObj,
    egtCasinoModel,
    setEgtCasinoModel,
    getCoinEvent,
    launchGis,
    setParly: updateParly,
    parly,
    parlyBet,
    setParlyBet,
    showParlyBet,
    setShowParlyBet,
    sokcetId,
    setSocketId,
    setInplaySocket,
    inplaySocket,
    dolaunchCasinoNew,
    // Added from old context
    showSidebar,
    setShowSidebar,
    handleShowSidebar,
    setGameTab,
    gameTab,
    keyTime,
    setKeyTime,
    loginError,
    setShowPosition,
    showPosition,
    refreshAmountLoader,
    setSearchTab,
    searchTab,
    showWidget,
    setShowWidget,
    setActiveWidget,
    activeWidget,
    messagelist: messagelist,
    announcement,
    setAnnouncement,
    active,
    setActive,
    setFooterLink,
    footerLink,
    setMessage,
    message,
    registerData,
    setRegisterData,
    sendOTP,
    otpVerify,
    createPinFunc,
    lang,
    setAffiliate,
    affiliate,
    withoutLogin,
    showRegForm,
    setShowRegForm,
    isChangeDate,
    setIsChangeDate,
    amountDeposit,
    setAmountDeposit,
    setShowDownloadBar,
    downloadBar,
    visiterId,
    sendMobileOTP,
    setSendOtpStatus,
    getSendOtpStatus,
    setSeconds,
    setMinutes,
    seconds,
    minutes,
    setWtype,
    wType,
    showCasinoIframe,
    casinoIframeUrl,
    setShowCasinoIframe,
    setCasinoIframeUrl,
    showMiniCasino,
    setShowMiniCasino,
    inPlayScore,
    setInPlayScore,
  };
  return (
    <AuthContext.Provider value={contextData}>
      {loading ? null : children}
    </AuthContext.Provider>
  );
};